export enum TransactionTypes {
  live = 1,
  liveHypothetical = 2,
  test = 3,
  valuation = 4,
  markedForDeletion = 5,
  internal = 6,
  ifrsComponent = 7,
}
